<section class="ma-banner" style="background-image:none; background-color:rgb(183,208,223);">
    <div class="main-content main-content--two">
        <div class="row">
            <div class="col-md-6">
                <div class="ma__page-header__sub-title ma__rich-text js-ma-rich-text" style="margin-top:30px;width:auto;">The Environmental Monitor is a bi-weekly publication that provides notice of new projects that have been submitted to the MEPA Office for review, other projects currently under review, certificates, and public notices.</div>
                <a class="btn btn-primary" style="border:1px solid #fff;margin-bottom:50px;" [routerLink]="['/home']" fragment="PublicationDate" (click)="onAnchorClick()">
                View recent edition&nbsp;&nbsp;<i class="fas fa-chevron-down-solid"></i></a>
                <h2 style="font-size:1.75rem; margin-bottom:0" id="SelectPublication">
                    Search a Publication<span class="ma__helper-text" style="font-weight:500" id="search-publication">
                            &nbsp;(Select a Year first)
                        </span>
                </h2>
                <form class="form-inline" style="margin-bottom:10px" aria-labelledby="SelectPublication">
                    <div class="form-group mb-6">
                        <label class="ma__select-box__label" for="select_year" style="margin-top: 10px;">Year</label>
                        <label class="sr-only">Select A Year</label>
                        <select class="form-control" id="select_year" name="select_year" style="margin-right:10px;" (ngModelChange)="setPublicationYear($event)" [(ngModel)]="publicationYear">
                                <option *ngFor="let yearItem of publicationYears" [ngValue]="yearItem">{{yearItem}}
                                </option>
                            </select>
                    </div>
                    <div class="form-group mb-6">
                        <label class="ma__select-box__label" for="select_date" style="margin-top: 10px;">Publication Date</label>
                        <label class="sr-only">Select a Date&nbsp;&nbsp;</label>
                        <select class="form-control" id="select_date" name="select_date" style="margin-right:10px;" [(ngModel)]="publicationSelected" #select_date="ngModel">
                                <option *ngFor="let publication of publications" [ngValue]="publication">{{
                                    (publication.publishDate !== undefined) ?
                                    (publication.publishDate| date :'MMM d, y') : "Publication Date"
                                    }}</option>
                            </select>
                    </div>
                    <div class="form-group mb-6">
                        <button class="btn btn-default mb-2" style="height:38px; margin-top:50px;" (click)="GetPublication()" type="button">
                                Go &gt;
                            </button>
                    </div>

                </form>
            </div>
            <div class="col-md-6 banner-image"></div>
        </div>
    </div>
</section>
<div class="monitor-date" id="project-list" style="background-color:rgb(255, 192, 153); color:#272772;">
    <div class="main-content main-content--two pubDate">
        <h2 style="padding-top:0; font-size:2rem" id="PublicationDate"> {{publicationLabel}}</h2>
    </div>
</div>
<div class="main-content main-content--two">
    <div [innerHTML]="announcement.messageContent" style="margin-top:20px;"></div>
</div>
<app-publications [inputPublishingId]="inputPublishingId"></app-publications>
<div [hidden]="!isProgress" class="loading">Loading&#8230;</div>